$(document).ready(function () {
    $(".u-content a").each(function () {
        // if (location.hostname !== this.hostname && this.hostname.length) {
        //   $(this).append($("<span>").addClass("c-icon-external-link"));
        // }

        var href = $(this).attr("href");
        if (href != null) {
            if (href.indexOf("file-size") >= 0) {
                var normalHref = href.split("?")[0];
                var paramsHref = href.split("?")[1];
        
                var sizeMatch = paramsHref.match(/file-size=(\d+(\.\d+)?)\+(\w+)/);
                if (sizeMatch) {
                    var size = sizeMatch[1]; // The full number (integer or decimal)
                    var unit = sizeMatch[3]; // The file size unit (MB, KB, etc.)
                }
                var typeMatch = paramsHref.match(/file-type=(\w+)/);
                if (typeMatch) {
                    var type = typeMatch[1];
                }        
        
                // Append the file size and type to the anchor tag
                $(this).append(
                    " (" + size + unit.toUpperCase() + " " + type.toUpperCase() + ")"
                );
        
        
                $(this).attr("href", normalHref);
            }
        }
    });
});